/** Only these responses guarantee the rejected turn never reached planning. */
export function conversationStartErrorCode(message: string | null) {
  try {
    const response: unknown = JSON.parse(message ?? '');
    if (response && typeof response === 'object' && 'code' in response) {
      if (
        response.code === 'CONVERSATION_BUSY' ||
        response.code === 'CONVERSATION_LOCK_UNAVAILABLE'
      ) {
        return response.code;
      }
    }
  } catch {
    // Other stream/model errors cannot safely replace local history.
  }
  return null;
}
